var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFlyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Menu/Off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.45068 6.64883C1.1158 6.74452 0.811714 6.92599 0.568501 7.17528C0.325289 7.42458 0.151383 7.73306 0.0639919 8.07021C-0.0233989 8.40735 -0.0212458 8.76147 0.0702382 9.09753C0.161722 9.43358 0.339366 9.73993 0.585593 9.98625L3.99794 13.3947V19.9815H10.5916L14.027 23.4119C14.2114 23.5979 14.4307 23.7456 14.6724 23.8465C14.914 23.9474 15.1732 23.9996 15.4351 24C15.6072 23.9997 15.7786 23.9775 15.9452 23.934C16.2822 23.8491 16.5909 23.6769 16.8402 23.4348C17.0895 23.1927 17.2706 22.8892 17.3653 22.5548L24 0L1.45068 6.64883ZM2.00674 8.57207L19.0365 3.55144L6.00015 16.5671V12.5666L2.00674 8.57207ZM15.4481 21.9978L11.4207 17.9812H7.4203L20.4546 4.95762L15.4481 21.9978Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlyer);
export default __webpack_public_path__ + "static/media/ic_flyer.b1079a9ce0e5effeab577b39e009ae2b.svg";
export { ForwardRef as ReactComponent };